export enum SideBarItems {
  Pen = "Pen",
  Highlighter = "Highlighter",
  Erasor = "Clear All",
  WhiteBoard = "WhiteBoard",
  NULL = null,
}
